module.exports = __webpack_public_path__ + "media/images/favicon/safari-pinned-tab-0c4f4f98393081ad4b121f6cfe9a75e9.svg";